/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  ImpersonationError,
  ImpersonationRequestRequest,
  ImpersonationToken
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type impersonateTokenCreateResponse200 = {
  data: ImpersonationToken
  status: 200
}

export type impersonateTokenCreateResponse400 = {
  data: ImpersonationError
  status: 400
}

export type impersonateTokenCreateResponse403 = {
  data: ImpersonationError
  status: 403
}

export type impersonateTokenCreateResponse404 = {
  data: ImpersonationError
  status: 404
}

export type impersonateTokenCreateResponse409 = {
  data: ImpersonationError
  status: 409
}

export type impersonateTokenCreateResponseSuccess = (impersonateTokenCreateResponse200) & {
  headers: Headers;
};
export type impersonateTokenCreateResponseError = (impersonateTokenCreateResponse400 | impersonateTokenCreateResponse403 | impersonateTokenCreateResponse404 | impersonateTokenCreateResponse409) & {
  headers: Headers;
};

export type impersonateTokenCreateResponse = (impersonateTokenCreateResponseSuccess | impersonateTokenCreateResponseError)

export const getImpersonateTokenCreateUrl = () => {




  return `/api/v1/impersonate/token/`
}

/**
 * Super-admin-only endpoint for impersonating another user.
 *
 * Starts a session for a target user (looked up by email) so a LiftAI
 * super-admin can sign in as that user and reproduce issues from their
 * perspective. The tokens authenticate the target and carry nothing of the
 * super-admin: everything done with them is done as the target.
 *
 * POST /api/v1/impersonate/token/
 *     Body: { "email": "user@example.com" }
 *     Returns: { "access": "...", "refresh": "...", "email": "user@example.com" }
 */
export const impersonateTokenCreate = async (impersonationRequestRequest: ImpersonationRequestRequest, options?: RequestInit): Promise<impersonateTokenCreateResponse> => {

  return customFetch<impersonateTokenCreateResponse>(getImpersonateTokenCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(impersonationRequestRequest)
  }
);}


